<template>
    <div>
        <!-- 步骤条 -->
        <el-steps align-center :active="active" show-icon finish-status="finish">
            <el-step title="房源信息" @click.native="on_click(1)"></el-step>
            <el-step title="房源描述" @click.native="on_click(2)"></el-step>
            <el-step title="配套设施" @click.native="on_click(3)"></el-step>
            <el-step title="真实图片" @click.native="on_click(4)"></el-step>
            <el-step title="价格规则" @click.native="on_click(5)"></el-step>
        </el-steps>
        <housingInformation
            :houseId="houseId"
            :customerId="customerId"
            :isStatus="isStatus"
            :cStewardId="cStewardId"
            :cSteward="cSteward"
            @active="activeNum($event)"
            @getAddress="getAddress"
            v-if="active == 1"
        ></housingInformation>
        <propertyDscription
            :houseId="houseId"
            :customerId="customerId"
            :isStatus="isStatus"
            @active="activeNum($event)"
            v-if="active == 2"
        ></propertyDscription>
        <ancillaryFacility
            :houseId="houseId"
            :customerId="customerId"
            :isStatus="isStatus"
            @active="activeNum($event)"
            v-if="active == 3"
        ></ancillaryFacility>
        <pictureDetails
            v-if="active == 4"
            :houseId="houseId"
            :customerId="customerId"
            :isStatus="isStatus"
            @active="activeNum($event)"
        ></pictureDetails>
        <PriceSpecifications
            :houseId="houseId"
            :customerId="customerId"
            :isStatus="isStatus"
            :roomId="roomId"
            @active="activeNum($event)"
            v-if="active == 5"
        ></PriceSpecifications>
    </div>
</template>

<script>
import propertyDscription from "../../components/rentalList/propertyDscription";
import housingInformation from "../../components/rentalList/housingInformation";
import ancillaryFacility from "../../components/rentalList/ancillaryFacility";
import pictureDetails from "../../components/rentalList/pictureDetails";
import PriceSpecifications from "../../components/rentalList/PriceSpecifications";

export default {
    components: {
        housingInformation,
        propertyDscription,
        ancillaryFacility,
        pictureDetails,
        PriceSpecifications
        // finish
    },
    name: "rental",
    data() {
        return {
            active: 1,
            customerId: "",
            isStatus: "",
            cStewardId: "",
            cSteward: "",
            gisId: '',
            roomId:'',
            pigUserId:'',
            houseId:'',
        };
    },
    created() {
        // console.log(this.$route);
        this.houseId= this.$route.query.houseId;//房间id
        this.customerId = this.$route.query.customerId;//房东
        this.isStatus = this.$route.query.isStatus;
        this.cStewardId = this.$route.query.cStewardId;//管家
        this.cSteward = this.$route.query.cSteward;
        this.roomId=this.$route.query.roomId;//小猪房源id
         this.pigUserId=this.$route.query.pigUserId;//小猪房东
    },
    methods: {
        on_click(e) {
            if (this.isStatus !== 1) return;
            if (e != "" || e != null) {
                this.active = e;
            }
        },
        activeNum(e) {
            this.active = e;
        },
        getAddress(gisId) {
            console.log(gisId, "获取到gisId")
            this.gisId = gisId
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-step__title.is-process {
    font-weight: 400;
}

/deep/ .el-step__title.is-finish {
    color: #f6b439;
}

/deep/ .el-step__head.is-finish {
    color: #f6b439;
    border-color: #f6b439;
}
</style>
